import { Model } from '@felicity/data-modelling';
import namespace from './apiNamespace.mjs';

/**
 * User profile
 */
export default class Profile extends Model {
  /**
   * The primary key for this user
   *
   * @type {string}
   */
  id;

  /**
   * The user name for this user
   *
   * @type {string}
   */
  userName;

  /**
   * The normalized user name for this user
   *
   * @type {string}
   */
  normalizedUserName;

  /**
   * The email address for this user
   *
   * @type {string}
   */
  email;

  /**
   * The normalized email address for this user
   *
   * @type {string}
   */
  normalizedEmail;

  /**
   * A flag indicating if a user has confirmed their email address
   *
   * @type {boolean}
   */
  emailConfirmed;

  /**
   * Telephone number for the user
   *
   * @type {string}
   */
  phoneNumber;

  /**
   * Flag indicating if a user has confirmed their telephone address
   *
   * @type {boolean}
   */
  phoneNumberConfirmed;

  /**
   * Flag indicating if two factor authentication is enabled for this user
   *
   * @type {boolean}
   */
  twoFactorEnabled;

  /**
   * The date and time, in UTC, when any user lockout ends
   *
   * @type {Date}
   */
  lockoutEnd;

  /**
   * Flag indicating if the user could be locked out
   *
   * @type {boolean}
   */
  lockoutEnabled;

  /**
   * The number of failed login attempts for the user
   *
   * @type {number}
   */
  accessFailedCount;

  /**
   * Any number of given name of the user
   *
   * @type {string}
   */
  firstName;

  /**
   * Family name of user
   *
   * @type {string}
   */
  lastName;

  /**
   * Profile picture
   *
   * @type {string}
   * @format uri
   */
  picture;

  /**
   * Name of the organisation the user is associated with
   *
   * @type {string}
   */
  organisationName;

  /**
   * Status of the organisation the user is associated with
   *
   * @type {string}
   */
  organisationStatus;

  /**
   * Activity scope of the organisation the user is associated with
   *
   * @type {string}
   */
  organisationActivityScope;

  /**
   * Reason why the organisation is interested in using the platform
   *
   * @type {string}
   */
  organisationReason;

  /**
   * Department of the organisation the user operates in
   *
   * @type {string}
   */
  department;

  /**
   * Assignment of the user in the organisation
   *
   * @type {string}
   */
  assignment;

  /**
   * Full name of user
   *
   * @type {string}
   */
  name;

  /**
   * Preferred language of the user
   *
   * @type {string}
   */
  preferredLanguage;

  /**
   * Associated user roles
   *
   * @type {string[]}
   */
  roles = [];
}

Profile.schema = `${namespace.FeliCity}.Profile`;
